/**
 * Aventross AGM — 문서 안 반복 목록(사람·표 행) 입력.
 *   목록 base('mem' · 'dir' · 'ctrl' · 'nd' · 'ns' · 'dir_1/int' …)마다 개수를 fill 값 `${base}__n` 에 두고,
 *   항목 값은 `${base}_${번호}/키` 로 저장한다. 값이 전부 fill 에 있어 Edit 저장/복원(values)에 그대로 실린다.
 */
import { useAgmFill, type AgmFillCtx } from '../../aura/agm/cdd/useCddFill';

export const countKey = (base: string) => `${base}__n`;

export function repeatCount(values: Record<string, string>, base: string): number {
  const n = parseInt(String(values[countKey(base)] ?? '').trim(), 10);
  return Number.isFinite(n) && n > 0 ? n : 0;
}

/** 목록 개수 지정 — 자동채움용(값은 그대로, 개수만) */
export function setRepeatCount(fill: AgmFillCtx, base: string, n: number) {
  fill.setValue(countKey(base), String(Math.max(0, n)));
}

/** i 번째 항목을 지우고 뒤 항목을 한 칸씩 당긴다(하위 목록 `dir_2/int_…` 포함) */
export function removeRepeatItem(fill: AgmFillCtx, base: string, id: number) {
  const n = repeatCount(fill.values, base);
  if (id < 1 || id > n) return;
  const pre = (j: number) => `${base}_${j}/`;
  for (let j = id; j < n; j += 1) {
    for (const k of Object.keys(fill.values)) if (k.startsWith(pre(j))) fill.setValue(k, '');
    for (const k of Object.keys(fill.values)) {
      if (k.startsWith(pre(j + 1))) fill.setValue(pre(j) + k.slice(pre(j + 1).length), fill.values[k]);
    }
  }
  for (const k of Object.keys(fill.values)) if (k.startsWith(pre(n))) fill.setValue(k, '');
  setRepeatCount(fill, base, n - 1);
}

export function useRepeat() {
  const fill = useAgmFill();
  return {
    ids: (base: string): number[] => Array.from({ length: repeatCount(fill.values, base) }, (_, i) => i + 1),
    add: (base: string) => setRepeatCount(fill, base, repeatCount(fill.values, base) + 1),
    remove: (base: string, id: number) => removeRepeatItem(fill, base, id),
  };
}
